/* global _ */
import angular from "angular";
import { buildDefaultRoutingProfile, routingProfileProps } from "./compliance.helpers";
import { buildDerivedRouteRequest } from "./deriveRoute";

angular.module("fleetviewApp")
  .service("ComplianceRoutingProfileService", ComplianceRoutingProfileService);

ComplianceRoutingProfileService.$inject = ["$translate", "UserProvider", "PCMRegion", "FleetViewAPI"];

//Contains helper functions and data for calculating derived routes from routing profile data
function ComplianceRoutingProfileService($translate, UserProvider, PCMRegion, FleetViewAPI) {

  function getRoutingProfileByPrescribedRouteId(prescribedRouteId) {
    const url = `${FleetViewAPI.config.apiUrl}v1/routing-profile/${prescribedRouteId}`;
    return FleetViewAPI.$http.get(url);
  }

  function getDerivedRouteRequest(latLonArray, routingProfile, offRouteMiles) {

    const region = PCMRegion[UserProvider.getUser().region];

    //If no routing profile is specified, use the most lenient/most default settings
    if (!routingProfile) {
      return buildDefaultRoutingProfile(latLonArray, offRouteMiles, region);
    }

    //Comes in format of string, "FiftyThreeFoot, NationalNetwork". Must parse and convert to bitflag
    if (routingProfile.classOverrides && typeof routingProfile.classOverrides === "string") {
      const classes = routingProfile.classOverrides.split(",");
      let bitFlag = 0;
      // TODO: replace for-of with iterator
      for (const cls of classes) {
        const clsNum = routingProfileProps.classOverrides[cls.trim()];
        bitFlag += clsNum;
      }
      routingProfile.classOverrides = bitFlag;
    }

    const isMetric = routingProfileProps.unitTypes[routingProfile.unitsOfMeasure] === 1;
    let weight = routingProfile.totalWeight;
    if (isMetric) {
      //Weight for metric routing profiles is in metric tons. But web service expects kilograms. 1 metric ton = 1000 kg
      weight *= 1000;
    }
    const request = buildDerivedRouteRequest({ region, routingProfile, latLonArray, offRouteMiles, weight, isMetric});

    //If vehicle type is set to auto, don't pass in TruckCfg
    if (routingProfileProps.vehicleTypes[routingProfile.vehicleType] === 2 && request.RoutingOptions) {
      delete request.RoutingOptions["TruckCfg"];
    }

    return request;
  }

  const service = { getDerivedRouteRequest, getRoutingProfileByPrescribedRouteId };
  return service;
}



// WEBPACK FOOTER //
// ./app/compliance/complianceRoutingProfile.service.js